/**
 * Minimal passive event shim for scroll-blocking events to reduce Chrome warnings
 * without pulling an external dependency.
 */
const passiveEvents = ["touchstart", "touchmove", "wheel"];

const originalAddEventListener = EventTarget.prototype.addEventListener;

EventTarget.prototype.addEventListener = function (type, listener, options) {
  if (passiveEvents.includes(type)) {
    if (options === undefined) {
      options = { passive: true };
    } else if (typeof options === "boolean") {
      options = { capture: options, passive: true };
    } else if (typeof options === "object" && options !== null) {
      options = { passive: true, ...options };
    }
  }
  return originalAddEventListener.call(this, type, listener, options);
};
